import { connect } from 'react-redux';
import { compose, withProps, renderNothing, branch, lifecycle } from 'recompose';
import { get } from 'lodash';
import Schedule from '../components/Schedule';
import { selector } from '../helpers';
import { activeShopMinInterval } from '../../../../../auth/selectors';
import {
  canUserModifyBarbers,
  canUserModifySchedules,
  canUserViewSchedules,
} from '../../../../../common/helpers/users';

const ScheduleContainer = compose(
  connect(state => ({
    barberId: selector(state, 'id'),
    schedules: selector(state, 'schedules'),
    daysOff: selector(state, 'days_off'),
    daysOn: selector(state, 'days_on'),
    minInterval: activeShopMinInterval(state),
    permissions: state.auth.permissions,
  })),
  withProps(
    props => ({
      canModify: canUserModifyBarbers(props.permissions) && canUserModifySchedules(props.permissions),
    })
  ),
  lifecycle({
    componentWillUpdate(nextProps) {
      const { change, schedules } = this.props;
      const futureStartDate = get(schedules, 'future.startDate');
      const nextFutureStartDate = get(nextProps.schedules, 'future.startDate');
      const nextFutureEndDate = get(nextProps.schedules, 'future.endDate');
      const endDate = get(schedules, 'current.endDate');
      const nextEndDate = get(nextProps.schedules, 'current.endDate');

      const endDateRemoved = endDate && !nextEndDate;
      const futureStartDateRemoved = futureStartDate && !nextFutureStartDate;
      const needToRemoveFutureEndDate = futureStartDateRemoved && nextFutureEndDate;

      if (endDateRemoved || needToRemoveFutureEndDate) {
        change('schedules.future.startDate', null);
        change('schedules.future.endDate', null);

        get(nextProps.schedules, 'future.workdays', [])
          .forEach((workday, index) => {
            change(`schedules.future.workdays[${index}].enabled`, false);
          });
      }
    },
  }),
  branch(
    props => !canUserViewSchedules(props.permissions),
    renderNothing,
  ),
)(Schedule);

export default ScheduleContainer;
